/** Gap between gallery thumbnails; matches spacing={1} of the thumbnail grid. */
export const THUMBNAIL_GAP_PX = 4;
